const COLLAPSE_KEY = 'rcsim-graph-collapsed';
const COLLAPSED_CLASS = 'graph-collapsed';

/** Collapse toggle on #bottombar so the bank graph can be hidden. */
export function enableGraphCollapse(): void {
  const app = document.getElementById('app')!;
  const bar = document.getElementById('bottombar')!;

  const toggle = document.createElement('button');
  toggle.id = 'graph-toggle';
  toggle.type = 'button';
  bar.prepend(toggle);

  const applyCollapsed = (collapsed: boolean) => {
    app.classList.toggle(COLLAPSED_CLASS, collapsed);
    const label = collapsed ? 'Show graph' : 'Hide graph';
    toggle.title = label;
    toggle.setAttribute('aria-label', label);
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  };

  applyCollapsed(restoreCollapsed());

  toggle.addEventListener('click', () => {
    const next = !app.classList.contains(COLLAPSED_CLASS);
    applyCollapsed(next);
    saveCollapsed(next);
  });
}

function restoreCollapsed(): boolean {
  try {
    return localStorage.getItem(COLLAPSE_KEY) === '1';
  } catch {
    return false;
  }
}

function saveCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(COLLAPSE_KEY, collapsed ? '1' : '0');
  } catch {
    // ignore
  }
}
